<template>
	<div v-bind:class="[{'Page':1,'loading':loading && !error,'errored':error},pageClass]" >
		<div v-if="error" class="Page_error" >
			<p><i class="fa fa-exclamation-triangle"></i></p>
			<p>{{ error }}</p>
		</div>
		<template v-else-if="!loading">
			<div class="Page_header" v-if="this.$slots.header" >
				<div class="Page_header_maxwidth" >
					<slot name="header" ></slot>
				</div>
			</div>
			<div class="Page_body" >
				<div :class="{'Page_body_maxwidth':!noPageMax}" >
					<slot>No content</slot>
				</div>
			</div>
		</template>
	</div>
</template>
<script>
	export default {
		props : ['loading','error','pageClass','noPageMax'],
	}
</script>